var React = require('react');

function MailOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mail"),React.createElement("rect",{"x":"48","y":"96","width":"416","height":"320","rx":"40","ry":"40","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","key":1}),React.createElement("path",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160l144 112 144-112","key":2})]);
}

MailOutline.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = MailOutline;

MailOutline.default = MailOutline;
